import { render, staticRenderFns } from "./CurrentPurchaseStock.vue?vue&type=template&id=24b35763&"
import script from "./CurrentPurchaseStock.vue?vue&type=script&lang=js&"
export * from "./CurrentPurchaseStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports